import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Height, Room, Search, TuneRounded as Tune } from '@material-ui/icons';
import {
  FormikAutocomplete50,
  FormikAutocompletePx,
  FormikTextField50,
  ModalSideBar,
  useLocalStorage,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useFormik } from 'formik';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

import FiltersOffre from './FiltersOffre';
import ResultsOffre from './ResultsOffre';

const filterSchema = yup.object().shape({
  keyword: yup.string(),
  businesses: yup.array(),
  cities: yup.string(),
  // cities: yup.array().of(yup.string()),
  contractTypes: yup.array(),
  degreeLevels: yup.array(),
  sectors: yup.array(),
  sector: yup.object().shape({
    id: yup.string(),
  }),
  domains: yup.array(),
  telework: yup.array(),
});

const Offres = ({
  isFetching,
  partnersAccepted,
  partnersRequested,
  partnersReceived,
  handleRefetch,
  accountInfos,
  load,
  offres,
  info,
  setInfo,
  page,
  setPage,
  totalElements,
  userInfo
}) => {
  const {
    css,
    theme: { spacing },
  } = useStyles(styles);
  const { searchParams, updateSearchParams } = useRouter();

  const {
    businesses: businessesParams,
    cities: citiesParams,
    contracts: contractsParams,
    degrees: degreesParams,
    domainsPro: domainsParams,
    keyword: keywoardParams,
    sectors: sectorsParams,
    telework: teleworkParams,
  } = searchParams;

  const [keywordRequest, setKeywordRequest] = useState(keywoardParams || '');
  const [businessesRequest, setBusinessesRequest] = useState(
    businessesParams || ''
  );
  const [citiesRequest, setCitiesRequest] = useState(citiesParams || '');
  const [contractsRequest, setContractsRequest] = useState(
    contractsParams || ''
  );
  const [degreeLevelsRequest, setDegreeLevelsRequest] = useState(
    degreesParams || ''
  );
  const [sectorsRequest, setSectorsRequest] = useState(sectorsParams || '');
  const [domainsRequest, setDomainsRequest] = useState(domainsParams || '');
  const [teleworkRequest, setTeleworkRequest] = useState(teleworkParams || '');

  const formik = useFormik({
    initialValues: {
      keyword: keywoardParams || '',
      businesses: businessesParams?.split(',') || '',
      cities: citiesParams || '',
      contractTypes: contractsParams?.split(',') || '',
      degreeLevels: degreesParams?.split(',') || '',
      sectors: sectorsParams?.split(',') || '',
      domains: domainsParams?.split(',') || '',
      telework: teleworkParams?.split(',') || '',
    },
    enableReinitialize: true,
    validationSchema: filterSchema,
    onSubmit: ({
      businesses,
      cities,
      contractTypes,
      degreeLevels,
      domains,
      keyword,
      sectors,
      telework,
    }) => {
      setKeywordRequest(keyword);
      setBusinessesRequest(businesses?.toString());
      setCitiesRequest(cities);
      setContractsRequest(contractTypes?.toString());
      setDegreeLevelsRequest(degreeLevels?.toString());
      setSectorsRequest(sectors?.toString());
      setDomainsRequest(domains?.toString());
      setTeleworkRequest(telework?.toString());
      updateSearchParams({
        keyword,
        businesses: businesses?.toString(),
        cities,
        contracts: contractTypes?.toString(),
        degrees: degreeLevels?.toString(),
        sectors: sectors?.toString(),
        domainsPro: domains?.toString(),
        telework: telework?.toString(),
      });
    },
  });

  const resetParamsUrl = () => {
    updateSearchParams({
      keyword: '',
      businesses: '',
      cities: '',
      contracts: '',
      degrees: '',
      sectors: '',
      domains: '',
      telework: '',
    });
  };

  // const [value, setValue] = useState('1');
  // const intl = useIntl();

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  const [filterOfferOpened, setFilterOfferOpened] = useState(false);

  const handleFilterOfferClose = () => {
    setFilterOfferOpened(false);
  };

  const handleFilterOfferOpen = () => {
    setFilterOfferOpened(true);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [autoKeywordJob, setAutoKeywordJob, removeAutoKeywordJob] =
    useLocalStorage('jobsKeyword');

  return (
    <>
      {offres?.length > 0 ? (
        <Grid
          item
          xs
          className={css({ background: '#F3F7FF', borderRadius: 10 })}
        >
          <ResultsOffre
            isFetching={isFetching}
            partnersAccepted={partnersAccepted}
            partnersRequested={partnersRequested}
            partnersReceived={partnersReceived}
            handleRefetch={handleRefetch}
            accountInfos={accountInfos}
            load={load}
            offres={offres}
            info={info}
            setInfo={setInfo}
            page={page}
            setPage={setPage}
            totalPage={totalElements}
            userInfo={userInfo}
          />
        </Grid>
      ) : (
        <Grid item xs className={css({ background: '#F3F7FF' })}>
          <div
            className={css({
              background: 'white',
              display: 'flex',
              justifyContent: 'center',
              padding: spacing(5),
            })}
          >
            Aucune offre correspondante trouvée.
          </div>
        </Grid>
      )}
      <ModalSideBar
        handleClose={handleFilterOfferClose}
        open={filterOfferOpened}
        title="Filtres"
        width="500px"
      >
        <FiltersOffre
          domainsParams={domainsParams}
          formik={formik}
          handleClose={handleFilterOfferClose}
          resetParamsUrl={resetParamsUrl}
        />
      </ModalSideBar>
    </>
  );
};

const styles = ({ spacing }) => ({});

export default Offres;
